import { Injectable } from "@angular/core";
import * as moment from "moment";
import { SignalRConnection } from "ng2-signalr";
import { UserPreference } from "../../models/UserPreference";
import { errorMessages, appSettings } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";

@Injectable()
export class CancelorderService {

  private hub: SignalRConnection;
  constructor(
    private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { }

  init(widget: any) {
    console.log("Cancel Orders");
    widget.dataLoaded = false;
    let currentDateTime = moment()
      .toDate()
      .getTime();
    widget.Title = "Cancelled Orders";     

    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub
      .start()
      .then(() => {
        console.log("Connection started!");
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor("broadcastCancelOrders").subscribe(
          (result: any) => {
            console.log("broadcastCancelOrders", result);

            let resultwid;
            let resultcreationtime;
            let lastUpdatedTime;
            widget.DataTable = null;
            
            if (result && result.length > 0) {            
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            } else {
              widget.errorMessage = errorMessages.noWidgetData;
            }

            if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              widget.chartOptions = null;             
             
              widget.DataTable = [{
                'columnsMatrix': [
                {DataColumn:'OrderId',DisplayColumn:'Order Id'},
                {DataColumn:'Facility',DisplayColumn:'Facility'},
                {DataColumn:'OrderStatus',DisplayColumn:'Order Status'},
                {DataColumn:'CancellationReason',DisplayColumn:'Cancellation Reason'},      
                {DataColumn:'LOCID',DisplayColumn:'LOCID'},
                {DataColumn:'CancelType',DisplayColumn:'Partial or Full Depick?'},
                {DataColumn:'LastUpdate',DisplayColumn:'Last Update'}],
                'rowsMatrix': [],'widgetData':[]
              }];
              const map = new Map(); //used to set unique orderid info
              for (const item of result) {
                if (!map.has(item.OrderId)) {
                  map.set(item.OrderId, true); // set any value to Map
                  let tDate = moment(item.LastUpdate);
                  item.LastUpdate = tDate.format(appSettings.DateTimeFormat);
                  widget.DataTable[0].widgetData.push(item);
                }
              }
              widget.DataTable[0].rowsMatrix = result;

              widget.errorMessage = null;
              if (widget.IfNoDataFound) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
            }
            widget.dataLoaded = true;
            this._commonService.lastUpdatedTime = lastUpdatedTime;
          },
          err => {
            console.log("listenFor broadcastCancelOrders error", err);
          }
        );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "CancelOrders";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub
          .invoke("GetWidgetData", widgetData)
          .then(data => {
            console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log("Error GetWidgetData", err);
          });
      })
      .catch(err => {
        console.log("Error while establishing connection", err);
      });
  }
  remove(widget: any) {
    this._widgetHelper.remove(widget);
  }
  reload(widget: any) {
    this._widgetHelper.reload(widget);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/cancelorder.service.ts